
export default {
  mounted() {
    this.alias['FormInput'] = 'form-masked-input';
  },
};
